import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const MicroAppList = lazy(() => import('./pages/MicroAppList'));
const MicroAppDetail = lazy(() => import('./pages/MicroAppDetail'));

export const microappsRoutes: RouteObject = {
  path: 'microapps',
  handle: { breadcrumb: 'MicroApps' },
  children: [
    { index: true, element: <MicroAppList />, handle: { breadcrumb: 'Configurations' } },
    { path: ':appId', element: <MicroAppDetail />, handle: { breadcrumb: 'Detail' } },
  ],
};
